var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"empty-screen-container",attrs:{"flat":"","tile":""}},[_c('v-icon',{staticClass:"empty-icon theme-hightext"},[_vm._v(_vm._s(_vm.$route.meta.icon))]),_c('v-card',{staticClass:"empty-title theme-title",attrs:{"flat":"","tile":""}},[_vm._v(_vm._s(_vm.$route.meta.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }